var more_btn = '<span class="show_more_btn">+ Show More</span>';
	
	$(".facets__collection .facets__collection__list").each(function(){
		var list_length = $(this).find('li').length;
		
		if(list_length > 5){
			$(this).append(more_btn);
		}
	})
		
// 			$('#shop-sidebar aside.widget.woocommerce.widget_layered_nav.woocommerce-widget-layered-nav ul.woocommerce-widget-layered-nav-list, #shop-sidebar aside.widget.woocommerce.widget_product_categories ul.product-categories').append(more_btn);
			
			$('.show_more_btn').click(function(){
				$(this).parent().toggleClass('show_more');
				if ($(this).text() == "+ Show More"){
					$(this).text("- Show Less")
				}	
				else{
					$(this).text("+ Show More");
				}
			});